import { ModuleWrapper } from '@/components'
import { Table } from '@/components_deprecated/Table'
import { PageType } from '@/modules/common/consts'
import { getNodes } from '@/utils/graphql'
import { useQuery } from '@apollo/client'
import { Loader } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { format } from 'date-fns'
import React from 'react'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import { SALARY_BASES } from './queries'

const ClickableRow = styled.tr`
  cursor: pointer;
`

/** Functional component that queries the salary bases and displays them in a table */
export const SalaryBases: React.JSX.CFC = () => {
  const translations = useTranslate({
    name: 'common.name',
    created: 'common.created',
    edit: 'common.edit',
    delete: 'common.delete',

    salaryBases: 'salary.salary-bases',
  })

  const navigate = useNavigate()

  const { data, loading } = useQuery(SALARY_BASES)

  if (loading) return <Loader.Dots />

  const salaryBases = getNodes(data?.allSalaryBases)

  return (
    <ModuleWrapper
      title={translations.salaryBases}
      page={PageType.SALARY_BASES}
      loading={loading}
    >
      <Table noBorders rowHoverBackground="gray10">
        <thead>
          <tr>
            <th>{translations.name}</th>
            <th>{translations.created}</th>
          </tr>
        </thead>

        <tbody>
          {salaryBases.map(salaryBase => (
            <ClickableRow
              key={salaryBase.id}
              onClick={() => void navigate(`/salary-bases/${salaryBase.id}`)}
            >
              <td>{salaryBase.name}</td>
              <td>{format(new Date(salaryBase.createdAt), 'dd.MM.yyyy')}</td>
            </ClickableRow>
          ))}
        </tbody>
      </Table>
    </ModuleWrapper>
  )
}
